/* global debounce */
if (!customElements.get("cart-note")) {
    class CartNote extends HTMLElement {
        constructor() {
            super();
            this.disclosure = this.closest("details");

            if (this.disclosure && this.disclosure.matches(".cart-note-disclosure")) {
                this.cartNoteToggle = this.disclosure.querySelector(".js-show-note");
            }

            this.fetchRequestOpts = {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            };

            this.init();
        }

        init() {
            this.debouncedHandleNoteChange = debounce(
                this.handleNoteChange.bind(this),
                300
            );
            // Save as soon as possible, avoid link-click not providing time to save
            this.addEventListener("input", this.debouncedHandleNoteChange);
        }

        handleNoteChange(evt) {
            if (this.cartNoteToggle) {
                const label = evt.target.value
                    ? theme.strings.editCartNote
                    : theme.strings.addCartNote;
                if (this.cartNoteToggle.textContent !== label)
                    this.cartNoteToggle.textContent = label;
            }

            this.fetchRequestOpts.body = JSON.stringify({ note: evt.target.value });
            fetch(theme.routes.cartUpdate, this.fetchRequestOpts);
        }
    }

    customElements.define("cart-note", CartNote);
}

jQuery(document).ready(function () {
    $(".line-item-property").each(function () {
        if (
            $(this).find(".line-item-property__label").text().trim() ===
            "fetch_discount:"
        ) {
            $(this).addClass("fil-d-none");
        }
    });

    // Group items by product_id
    const productGroups = {};

    if ($(".template-cart").length !== 0) {
        $(".fetch_discount").each(function () {
            const productId = $(this).data("productid");
            if (!productGroups[productId]) {
                productGroups[productId] = [];
            }
            productGroups[productId].push($(this));
        });
    } else {
        $(".cart-drawer__content-item>.cart-item-list__body>div").each(function () {
            const productId = $(this).data("productid");
            if (!productGroups[productId]) {
                productGroups[productId] = [];
            }
            productGroups[productId].push($(this));
        });
    }

    console.log("Product Groups323232323232:", productGroups);

    // Process each product group
    $.each(productGroups, function (productId, items) {
        // Find item with maximum quantity in this group
        let maxQuantity = 0;
        let maxQuantityItem = null;

        items.forEach(function (item) {
            const quantity = parseInt(item.data("quantity") || 1);
            if (quantity > maxQuantity) {
                maxQuantity = quantity;
                maxQuantityItem = item;
            }
        });

        // Process each item in the group
        items.forEach(function (item) {
            const quantity = parseInt(item.data("quantity") || 1);
            const originalPrice = parseFloat(
                item.find(".price--end").text().replace("$", "").replace(/,/g, "")
            );
            console.log("Original Price...............!!!!!!!", originalPrice);
            let discountedPrice = originalPrice;

            if (maxQuantity >= 2) {
                if (item === maxQuantityItem) {
                    // For item with max quantity
                    const remainder = maxQuantity - 2;
                    const discountAmount = remainder * 50 + 25;
                    discountedPrice = originalPrice - discountAmount;
                } else {
                    // For other items
                    discountedPrice = originalPrice - quantity * 50;
                }
            } else if (maxQuantity === 2) {
                if (item === maxQuantityItem) {
                    // For item with quantity 2
                    discountedPrice = originalPrice - 25;
                } else {
                    // For other items
                    discountedPrice = originalPrice - quantity * 50;
                }
            } else if (maxQuantity === 1) {
                // Find position of this item in the group
                const index = items.indexOf(item);
                if (index === 0) {
                    // First item - no discount
                    discountedPrice = originalPrice;
                } else if (index === 1) {
                    // Second item - $25 discount
                    discountedPrice = originalPrice - 25;
                } else {
                    // All other items - $50 discount
                    discountedPrice = originalPrice - 50;
                }
            }

            // Ensure discounted price doesn't go below 0
            discountedPrice = Math.max(discountedPrice, 0);

            // Update the discounted price display
            const discountedElement = item.find(".price--discounted");
            console.log("Discounted Price:", discountedPrice);
            console.log("Discounted Price toFixed(2):", discountedPrice.toFixed(2));
            if (discountedElement.length) {
                discountedElement.text("$" + discountedPrice.toFixed(2));
            } else {
                // Create discounted element if it doesn't exist
                item
                    .find(".cart-item__price-wrapper")
                    .append(
                        '<span class="theme-money price price--discounted">$' +
                        discountedPrice.toFixed(2) +
                        "</span>"
                    );
            }

            // Add/remove classes for styling
            if (discountedPrice < originalPrice) {
                const priceEndElement = item.find(".price--end");
                // Check if the element does NOT have the 'price-bfre-disc' class
                if (!priceEndElement.hasClass("price-bfre-discount")) {
                    priceEndElement.addClass("price-bfre-discount");
                }
            } else if (discountedPrice === originalPrice) {
                item.find(".price--end").removeClass("price-bfre-discount");
                item.find(".price--discounted").remove();
            }
        });
    });

    var fetchildisvalue = localStorage.getItem("fetchildisvalue");

    if (fetchildisvalue) {
        jQuery(".disvalue").text(`-$${fetchildisvalue}.00`);
        jQuery(".cart-drawer__footer span.cart-discount__amount.theme-money").text(
            `-$${fetchildisvalue}.00`
        );
    }

    fetch("/cart.js")
        .then((response) => response.json())
        .then((cart) => {
            console.log("Start Full cart object:", cart);
            console.log("Start Cart items:", cart.items);
            let totalPrice = 0;

            // Process items to expand quantities > 2 into separate items
            const expandedItems = [];
            const fnlDis = []; // Initialize as array

            cart.items.forEach((item) => {
                const priceInCents = parseFloat(item.final_line_price);
                const priceInDollars = priceInCents / 100;
                totalPrice += priceInDollars;
                console.log("Original Price:", priceInDollars.toFixed(2));
                if (item.properties && item.properties.fetch_discount !== undefined) {
                    if (item.quantity >= 2) {
                        // Create multiple entries for quantities > 2
                        for (let i = 0; i < item.quantity; i++) {
                            const clonedItem = JSON.parse(JSON.stringify(item));
                            clonedItem.quantity = 1;
                            clonedItem.line_price = clonedItem.price; // Adjust line price for single item
                            expandedItems.push(clonedItem);
                        }
                    } else {
                        // Add the item as-is for quantities <= 2
                        expandedItems.push(item);
                    }
                }
            });
            console.log("Total Price.toFixed(2):", totalPrice.toFixed(2));
            console.log("Total Price:", totalPrice);
            // Group by product_id
            const groupedByProductId = expandedItems.reduce((groups, item) => {
                const productId = item.product_id;
                if (!groups[productId]) {
                    groups[productId] = [];
                }
                groups[productId].push(item);
                return groups;
            }, {});

            // Convert to array of groups
            const result = Object.values(groupedByProductId);

            console.log("Expanded items with fetch_discount:", expandedItems);
            console.log("Grouped by product_id:", result);

            // Calculate discount based on group size
            result.forEach((group) => {
                console.log("Group:", group.length);
                let groupDis = 0;

                if (group.length > 2) {
                    const afterTwo = group.length - 2;
                    groupDis = afterTwo * 50 + 25; // 50% for each additional beyond 2, plus 25% for first two
                } else if (group.length === 2) {
                    groupDis = 25; // 25% for two items
                }
                // No discount for single items (groupDis remains 0)

                fnlDis.push(groupDis);
                console.log("Discount for this group:", groupDis);
            });

            // Calculate total discount by summing all group discounts
            const totalDiscount = fnlDis.reduce((sum, discount) => sum + discount, 0);

            console.log("Final discount array:", fnlDis);
            console.log("Total discount:", totalDiscount);

            // if (totalDiscount > 0) {
            console.log("InIF...........:", totalDiscount);
            updateDiscountCoupenCart(totalDiscount)
                .then(() => {
                    // This will only execute after updateDiscountCoupenCart completes
                    updateDiscountDisplay(totalDiscount, totalPrice);
                })
                .catch((error) => {
                    console.error("Failed to update discount:", error);
                });

            // }
            // else {
            //   console.log('InELSE...........:', totalDiscount);
            //   fetch('/cart/update.js', {
            //     method: 'POST',
            //     headers: {
            //       'Content-Type': 'application/json'
            //     },
            //     body: JSON.stringify({ discount_code: '' })
            //   }).then(() => {
            //     window.location.reload();
            //   });
            // }

            return totalDiscount;
        })
        .catch((error) => console.error("Error fetching cart:", error));

    // Event delegation for remove buttons
    jQuery(document).on(
        "click",
        ".cart-item__column.cart-item__quantity a.cart-item__remove",
        function (e) {
            console.log("Remove button clicked");
            setTimeout(() => {
                fetch("/cart.js")
                    .then((response) => response.json())
                    .then((cart) => {
                        console.log("Plus Minus Full cart object:", cart);
                        console.log("Plus Minus Cart items:", cart.items);
                        let totalPrice = 0;

                        // Process items to expand quantities > 2 into separate items
                        const expandedItems = [];
                        const fnlDis = []; // Initialize as array

                        cart.items.forEach((item) => {
                            const priceInCents = parseFloat(item.final_line_price);
                            const priceInDollars = priceInCents / 100;
                            totalPrice += priceInDollars;
                            console.log(
                                "Plus Minus Original Price:",
                                priceInDollars.toFixed(2)
                            );
                            if (
                                item.properties &&
                                item.properties.fetch_discount !== undefined
                            ) {
                                if (item.quantity >= 2) {
                                    // Create multiple entries for quantities > 2
                                    for (let i = 0; i < item.quantity; i++) {
                                        const clonedItem = JSON.parse(JSON.stringify(item));
                                        clonedItem.quantity = 1;
                                        clonedItem.line_price = clonedItem.price; // Adjust line price for single item
                                        expandedItems.push(clonedItem);
                                    }
                                } else {
                                    // Add the item as-is for quantities <= 2
                                    expandedItems.push(item);
                                }
                            }
                        });

                        // Group by product_id
                        const groupedByProductId = expandedItems.reduce((groups, item) => {
                            const productId = item.product_id;
                            if (!groups[productId]) {
                                groups[productId] = [];
                            }
                            groups[productId].push(item);
                            return groups;
                        }, {});

                        // Convert to array of groups
                        const result = Object.values(groupedByProductId);

                        console.log("Expanded items with fetch_discount:", expandedItems);
                        console.log("Grouped by product_id:", result);

                        // Calculate discount based on group size
                        result.forEach((group) => {
                            console.log("Group:", group.length);
                            let groupDis = 0;

                            if (group.length > 2) {
                                const afterTwo = group.length - 2;
                                groupDis = afterTwo * 50 + 25; // 50% for each additional beyond 2, plus 25% for first two
                            } else if (group.length === 2) {
                                groupDis = 25; // 25% for two items
                            }
                            // No discount for single items (groupDis remains 0)

                            fnlDis.push(groupDis);
                            console.log("Discount for this group:", groupDis);
                        });

                        // Calculate total discount by summing all group discounts
                        const totalDiscount = fnlDis.reduce(
                            (sum, discount) => sum + discount,
                            0
                        );

                        console.log("Final discount array:", fnlDis);
                        console.log("Total discount:", totalDiscount);

                        // if (totalDiscount > 0) {
                        console.log("InIF...........:", totalDiscount);
                        updateDiscountCoupenCart(totalDiscount)
                            .then(() => {
                                // This will only execute after updateDiscountCoupenCart completes
                                updateDiscountDisplay(totalDiscount, totalPrice);
                            })
                            .catch((error) => {
                                console.error("Failed to update discount:", error);
                            });

                        // }
                        // else {
                        //   console.log('InELSE...........:', totalDiscount);
                        //   fetch('/cart/update.js', {
                        //     method: 'POST',
                        //     headers: {
                        //       'Content-Type': 'application/json'
                        //     },
                        //     body: JSON.stringify({ discount_code: '' })
                        //   }).then(() => {
                        //     // window.location.reload();
                        //     window.location.href = `/discount/${fetchildisid}?redirect_to=cart`;
                        //   });
                        // }

                        // Group items by product_id
                        const productGroups = {};

                        if ($(".template-cart").length !== 0) {
                            $(".fetch_discount").each(function () {
                                const productId = $(this).data("productid");
                                if (!productGroups[productId]) {
                                    productGroups[productId] = [];
                                }
                                productGroups[productId].push($(this));
                            });
                        } else {
                            $(".cart-drawer__content-item>.cart-item-list__body>div").each(function () {
                                const productId = $(this).data("productid");
                                if (!productGroups[productId]) {
                                    productGroups[productId] = [];
                                }
                                productGroups[productId].push($(this));
                            });
                        }

                        // Process each product group
                        $.each(productGroups, function (productId, items) {
                            // Find item with maximum quantity in this group
                            let maxQuantity = 0;
                            let maxQuantityItem = null;

                            items.forEach(function (item) {
                                const quantity = parseInt(item.data("quantity") || 1);
                                if (quantity > maxQuantity) {
                                    maxQuantity = quantity;
                                    maxQuantityItem = item;
                                }
                            });

                            // Process each item in the group
                            items.forEach(function (item) {
                                const quantity = parseInt(item.data("quantity") || 1);
                                const originalPrice = parseFloat(
                                    item
                                        .find(".price--end")
                                        .text()
                                        .replace("$", "")
                                        .replace(/,/g, "")
                                );
                                let discountedPrice = originalPrice;

                                if (maxQuantity >= 2) {
                                    if (item === maxQuantityItem) {
                                        // For item with max quantity
                                        const remainder = maxQuantity - 2;
                                        const discountAmount = remainder * 50 + 25;
                                        discountedPrice = originalPrice - discountAmount;
                                    } else {
                                        // For other items
                                        discountedPrice = originalPrice - quantity * 50;
                                    }
                                } else if (maxQuantity === 2) {
                                    if (item === maxQuantityItem) {
                                        // For item with quantity 2
                                        discountedPrice = originalPrice - 25;
                                    } else {
                                        // For other items
                                        discountedPrice = originalPrice - quantity * 50;
                                    }
                                } else if (maxQuantity === 1) {
                                    // Find position of this item in the group
                                    const index = items.indexOf(item);
                                    if (index === 0) {
                                        // First item - no discount
                                        discountedPrice = originalPrice;
                                    } else if (index === 1) {
                                        // Second item - $25 discount
                                        discountedPrice = originalPrice - 25;
                                    } else {
                                        // All other items - $50 discount
                                        discountedPrice = originalPrice - 50;
                                    }
                                }

                                // Ensure discounted price doesn't go below 0
                                discountedPrice = Math.max(discountedPrice, 0);

                                // Update the discounted price display
                                const discountedElement = item.find(".price--discounted");
                                if (discountedElement.length) {
                                    discountedElement.text("$" + discountedPrice.toFixed(2));
                                } else {
                                    // Create discounted element if it doesn't exist
                                    item
                                        .find(".cart-item__price-wrapper")
                                        .append(
                                            '<span class="price price--discounted">$' +
                                            discountedPrice.toFixed(2) +
                                            "</span>"
                                        );
                                }

                                // Add/remove classes for styling
                                if (discountedPrice < originalPrice) {
                                    const priceEndElement = item.find(".price--end");
                                    // Check if the element does NOT have the 'price-bfre-disc' class
                                    if (!priceEndElement.hasClass("price-bfre-discount")) {
                                        priceEndElement.addClass("price-bfre-discount");
                                    }
                                } else if (discountedPrice === originalPrice) {
                                    item.find(".price--end").removeClass("price-bfre-discount");
                                    item.find(".price--discounted").remove();
                                }
                            });
                        });

                        return totalDiscount;
                    })
                    .catch((error) => console.error("Error fetching cart:", error));
            }, 2000);
        }
    );

    // $(document).ready(function () {
    //     // Handle quantity increase
    //     $('.quantity-up').on('click', function (e) {
    //         e.preventDefault();
    //         alert('Testing - Quantity increased!');
    //         // You can still proceed with the default behavior after the alert
    //         window.location.href = $(this).attr('href');
    //     });

    //     // Handle quantity decrease
    //     $('.quantity-down').on('click', function (e) {
    //         e.preventDefault();
    //         alert('Testing - Quantity decreased!');
    //         // You can still proceed with the default behavior after the alert
    //         window.location.href = $(this).attr('href');
    //     });

    //     // Handle direct input changes
    //     $('.cart-item__quantity-input').on('change', function () {
    //         alert('Testing - Quantity changed to: ' + $(this).val());
    //         // You would typically submit the form or make an AJAX call here
    //     });
    // });

    // Listen for all quantity changes in the cart
    // jQuery(document).on('change', 'input.cart-item__quantity-input[type="number"]', function () {
    jQuery(document).on(
        "change click",
        'input.cart-item__quantity-input[type="number"], .quantity-up, .quantity-down',
        function () {
            console.log("Quantity changed:", jQuery(this).val());

            // Optional: Get the specific item details
            const itemId =
                jQuery(this).data("variant-id") ||
                jQuery(this).closest(".cart-item").data("variant-id");
            const newQuantity = jQuery(this).val();

            console.log(`Item ${itemId} quantity changed to ${newQuantity}`);
            // alert(`Item ${itemId} quantity changed to ${newQuantity}`);
            setTimeout(() => {
                console.log("Fetching cart after quantity change...");
                fetch("/cart.js")
                    .then((response) => response.json())
                    .then((cart) => {
                        console.log("PlusMinus Full cart object:", cart);
                        console.log("PlusMinus Cart items:", cart.items);
                        let totalPrice = 0;

                        // Process items to expand quantities > 2 into separate items
                        const expandedItems = [];
                        const fnlDis = []; // Initialize as array

                        cart.items.forEach((item) => {
                            const priceInCents = parseFloat(item.final_line_price);
                            const priceInDollars = priceInCents / 100;
                            totalPrice += priceInDollars;
                            console.log("Original Price:", priceInDollars.toFixed(2));
                            if (
                                item.properties &&
                                item.properties.fetch_discount !== undefined
                            ) {
                                if (item.quantity >= 2) {
                                    // Create multiple entries for quantities > 2
                                    for (let i = 0; i < item.quantity; i++) {
                                        const clonedItem = JSON.parse(JSON.stringify(item));
                                        clonedItem.quantity = 1;
                                        clonedItem.line_price = clonedItem.price; // Adjust line price for single item
                                        expandedItems.push(clonedItem);
                                    }
                                } else {
                                    // Add the item as-is for quantities <= 2
                                    expandedItems.push(item);
                                }
                            }
                        });

                        // Group by product_id
                        const groupedByProductId = expandedItems.reduce((groups, item) => {
                            const productId = item.product_id;
                            if (!groups[productId]) {
                                groups[productId] = [];
                            }
                            groups[productId].push(item);
                            return groups;
                        }, {});

                        // Convert to array of groups
                        const result = Object.values(groupedByProductId);

                        console.log("Expanded items with fetch_discount:", expandedItems);
                        console.log("Grouped by product_id:", result);

                        // Calculate discount based on group size
                        result.forEach((group) => {
                            console.log("Group:", group.length);
                            let groupDis = 0;

                            if (group.length > 2) {
                                const afterTwo = group.length - 2;
                                groupDis = afterTwo * 50 + 25; // 50% for each additional beyond 2, plus 25% for first two
                            } else if (group.length === 2) {
                                groupDis = 25; // 25% for two items
                            }
                            // No discount for single items (groupDis remains 0)

                            fnlDis.push(groupDis);
                            console.log("Discount for this group:", groupDis);
                        });

                        // Calculate total discount by summing all group discounts
                        const totalDiscount = fnlDis.reduce(
                            (sum, discount) => sum + discount,
                            0
                        );

                        console.log("Final discount array:", fnlDis);
                        console.log("Total discount:", totalDiscount);

                        // if (totalDiscount > 0) {
                        updateDiscountCoupenCart(totalDiscount)
                            .then(() => {
                                // This will only execute after updateDiscountCoupenCart completes
                                updateDiscountDisplay(totalDiscount, totalPrice);
                            })
                            .catch((error) => {
                                console.error("Failed to update discount:", error);
                            });

                        // }

                        // Group items by product_id
                        const productGroups = {};

                        if ($(".template-cart").length !== 0) {
                            $(".fetch_discount").each(function () {
                                const productId = $(this).data("productid");
                                if (!productGroups[productId]) {
                                    productGroups[productId] = [];
                                }
                                productGroups[productId].push($(this));
                            });
                        } else {
                            $(".cart-drawer__content-item>.cart-item-list__body>div").each(function () {
                                const productId = $(this).data("productid");
                                if (!productGroups[productId]) {
                                    productGroups[productId] = [];
                                }
                                productGroups[productId].push($(this));
                            });
                        }

                        // Process each product group
                        $.each(productGroups, function (productId, items) {
                            // Find item with maximum quantity in this group
                            let maxQuantity = 0;
                            let maxQuantityItem = null;

                            items.forEach(function (item) {
                                const quantity = parseInt(item.data("quantity") || 1);
                                if (quantity > maxQuantity) {
                                    maxQuantity = quantity;
                                    maxQuantityItem = item;
                                }
                            });

                            // Process each item in the group
                            items.forEach(function (item) {
                                const quantity = parseInt(item.data("quantity") || 1);
                                const originalPrice = parseFloat(
                                    item
                                        .find(".price--end")
                                        .text()
                                        .replace("$", "")
                                        .replace(/,/g, "")
                                );
                                let discountedPrice = originalPrice;

                                if (maxQuantity >= 2) {
                                    if (item === maxQuantityItem) {
                                        // For item with max quantity
                                        const remainder = maxQuantity - 2;
                                        const discountAmount = remainder * 50 + 25;
                                        discountedPrice = originalPrice - discountAmount;
                                    } else {
                                        // For other items
                                        discountedPrice = originalPrice - quantity * 50;
                                    }
                                } else if (maxQuantity === 2) {
                                    if (item === maxQuantityItem) {
                                        // For item with quantity 2
                                        discountedPrice = originalPrice - 25;
                                    } else {
                                        // For other items
                                        discountedPrice = originalPrice - quantity * 50;
                                    }
                                } else if (maxQuantity === 1) {
                                    // Find position of this item in the group
                                    const index = items.indexOf(item);
                                    if (index === 0) {
                                        // First item - no discount
                                        discountedPrice = originalPrice;
                                    } else if (index === 1) {
                                        // Second item - $25 discount
                                        discountedPrice = originalPrice - 25;
                                    } else {
                                        // All other items - $50 discount
                                        discountedPrice = originalPrice - 50;
                                    }
                                }

                                // Ensure discounted price doesn't go below 0
                                discountedPrice = Math.max(discountedPrice, 0);

                                // Update the discounted price display
                                const discountedElement = item.find(".price--discounted");
                                if (discountedElement.length) {
                                    discountedElement.text("$" + discountedPrice.toFixed(2));
                                } else {
                                    // Create discounted element if it doesn't exist
                                    item
                                        .find(".cart-item__price-wrapper")
                                        .append(
                                            '<span class="price price--discounted">$' +
                                            discountedPrice.toFixed(2) +
                                            "</span>"
                                        );
                                }

                                // Add/remove classes for styling
                                if (discountedPrice < originalPrice) {
                                    const priceEndElement = item.find(".price--end");
                                    // Check if the element does NOT have the 'price-bfre-disc' class
                                    if (!priceEndElement.hasClass("price-bfre-discount")) {
                                        priceEndElement.addClass("price-bfre-discount");
                                    }
                                } else if (discountedPrice === originalPrice) {
                                    item.find(".price--end").removeClass("price-bfre-discount");
                                    item.find(".price--discounted").remove();
                                }
                            });
                        });

                        return totalDiscount;
                    })
                    .catch((error) => console.error("Error fetching cart:", error));
            }, 3000);
        }
    );
});

async function updateDiscountCoupenCart(finalDiscountedAmount) {
    console.log("Final Discounted Amount12345:", finalDiscountedAmount);
    var fetchildisid = localStorage.getItem("fetchildisid");

    if (fetchildisid) {
        console.log("fetchildisid exists. checking the discount code...");

        try {
            const encodedId = encodeURIComponent(fetchildisid);
            console.log(
                `Getting discount code...${API_BASE_URL}/discount/${encodedId}`
            );
            // Make API Request
            const response = await fetch(`${API_BASE_URL}/discount/${encodedId}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            });
            console.log("Response:", response);

            const result = await response.json();

            console.log("Discount Got successfully:", result);
            console.log("result error", result.errors);

            // if existing discount found and no error found.
            if (result.success === true) {
                // Update Discount start
                console.log("Get Order Discount Response:", result.data.id);

                var getPricetoUpdated = result.data.amount;
                getPricetoUpdated = parseFloat(finalDiscountedAmount);

                console.log(
                    "the updated discount amount to be updated:",
                    getPricetoUpdated
                );

                // updating the discount since it is exists already.
                console.log("Discount Already exists. updating the disount code...");
                var sessionDisCode = localStorage.getItem("fetchildiscode");

                try {
                    // Make API Request
                    console.log(
                        `Creating new discount code...${API_BASE_URL}/discount/update`
                    );
                    // Make API Request
                    const response = await fetch(`${API_BASE_URL}/discount/update`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "X-Requested-With": "XMLHttpRequest", // Add this header
                        },
                        body: JSON.stringify({
                            discountId: fetchildisid,
                            discounCode: sessionDisCode,
                            newAmount: getPricetoUpdated,
                        }),
                    });
                    console.log("Response:", response);

                    const updateresult = await response.json();

                    console.log("Updated Order Discount Response:", updateresult);

                    return sessionDisCode;
                } catch (error) {
                    console.error(
                        "Unexpected Error while updating the Discount Code:",
                        error
                    );
                    return false;
                }
                // Update Discount end
            }
            return;
        } catch (error) {
            console.error("Unexpected Get discount Error:getresult", error);
            return false;
        }
    }
}

// Function to update discount display
function updateDiscountDisplay(discountAmount, totalPrice) {
    jQuery(".disvalue").text(`-$${discountAmount}.00`);
    jQuery(".cart-drawer__footer span.cart-discount__amount.theme-money").text(
        `-$${discountAmount}.00`
    );
    jQuery(".totals__total-value").text(`$${totalPrice - discountAmount}.00 USD`);
    jQuery(".cart-drawer__footer .subtotal span.theme-money").text(
        `$${totalPrice - discountAmount}.00`
    );
    localStorage.setItem("fetchildisvalue", discountAmount);
    $(".line-item-property").each(function () {
        if (
            $(this).find(".line-item-property__label").text().trim() ===
            "fetch_discount:"
        ) {
            $(this).addClass("fil-d-none");
        }
    });
    console.log("Discount updating...", discountAmount);
}
